import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PublicOnly({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();
  // Existing sessions may need a new tenant identity proof after a policy change.
  if (location.pathname === "/login" && new URLSearchParams(location.search).has("org_id")) return children;
  if (ready && user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return children;
}
